import {
  Component,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  Input,
  Output,
  OnInit,
  OnDestroy,
  AfterViewInit,
  EventEmitter
} from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { CustomModalConfig } from "./custom-modal.config.interface";
import { CustomModalService } from "./custom-modal.service";

@Component({
  selector: "custom-modal",
  templateUrl: "custom-modal.component.html",
  styleUrls: ["custom-modal.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CustomModalComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("modal") public modal: ModalDirective;
  @Input() id: string;
  @Input() config: CustomModalConfig
  @Output() cancleButtonCallback = new EventEmitter<any>();
  @Output() okButtonCallback = new EventEmitter<any>();
  @Output() closeModalButtonCallback = new EventEmitter<any>();
  @Output() onScrollEvent = new EventEmitter<any>();
  private element: any;
  closeStyle: any = {}

  constructor(
    private modalService: CustomModalService,
    private el: ElementRef
  ) {
    this.element = el.nativeElement;
    this.closeStyle  = {'display': 'block'}
  }
  
  ngAfterViewInit() {
    this.initModalDirectiveConfig()
  }

  ngOnInit(): void {
    if (!this.id) {
      console.error("modal must have an id");
      return;
    }

    // display on top of everything
    document.body.appendChild(this.element);

    // add self (this modal instance) to the modal service so it's accessible from controllers
    this.modalService.add(this);

    this.initModalConfig()
  }

  // remove self from modal service when component is destroyed
  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  initModalDirectiveConfig() {
    if (this.modal && this.config.backdrop) {
      this.modal.config.backdrop = this.config.backdrop;
    }
  }

  initModalConfig() {
    this.config.showCancelButton = this.config.showCancelButton || false;
    this.config.showOkButton = this.config.showOkButton || false;
    this.config.cancelButtonText = this.config.cancelButtonText || 'Cancel';
    this.config.OkButtonText = this.config.OkButtonText || 'OK';
    this.config.OkButtonStyle = this.config.OkButtonStyle || {};
    this.config.cancelButtonStyle = this.config.cancelButtonStyle || {};
    this.config.alignButton = this.config.alignButton || 'right';
  }

  alignButton() {
    let type = {
      'left': 'flex-start',
      'center': 'center',
      'right': 'flex-end',
    }
    return {
      'justify-content': type[this.config.alignButton]
    }
  }

  cancleCallback() {
    this.cancleButtonCallback.emit(true)
    this.close()
  }

  okCallback() {
    this.okButtonCallback.emit(true)
    this.close()
  }

  closeModalCallback(): void {
    this.closeModalButtonCallback.emit(true)
    this.close()
  }

  scrollEvent(event) {
    this.onScrollEvent.emit(event)
  }

  // open modal
  open(modal:any = null): void {
    if(modal.id == 'show-term-select' || modal.id == 'show-term-select-mobile'){
      this.closeStyle  = {'display': 'none'}
    }
    this.modal.show();
  }

  // close modal
  close(): void {
    this.modal.hide();
  }
}
